const ASTRID_PORTAL_APP_URL = window.__CONFIG__.astridPortalAppUrl;
const OTP_EXPIRATION_DURATION_IN_SECONDS = 60;
let otpTimerIntervalId = null;

document.addEventListener('DOMContentLoaded', function () {
  const requestOtpBtn = document.querySelector('[data-request-otp]');
  const verifyOtpBtn = document.querySelector('[data-verify-otp]');
  const requestOtpForm = document.querySelector('[data-request-otp-form]');
  const verifyOtpForm = document.querySelector('[data-verify-otp-form]');

  if (requestOtpBtn && requestOtpForm) {
    requestOtpBtn.addEventListener('click', handleRequestOtp);
    requestOtpForm.addEventListener('input', validateForm);
  }

  if (verifyOtpBtn && verifyOtpForm) {
    verifyOtpBtn.addEventListener('click', handleVerifyOtp);
    verifyOtpForm.addEventListener('input', validateForm);
    verifyOtpForm.addEventListener('keydown', validateForm);
    verifyOtpForm.addEventListener('paste', validateForm);
  }
});

async function handleRequestOtp(e) {
  e.preventDefault();

  const form = document.querySelector('[data-request-otp-form]');
  const requestOtpBtn = document.querySelector('[data-request-otp]');
  if (!form) return;

  const formData = new FormData(form);

  resetFormErrors(form);
  resetGeneralMessages();

  try {
    setFormDisabled(form);

    const res = await fetch(`${ASTRID_PORTAL_APP_URL}/api/patient/request-otp`, {
      method: 'POST',
      body: formData,
    });

    const result = await res.json();

    if (result.error?.fieldErrors) {
      showFieldErrors(result.error.fieldErrors);
      setFormDisabled(form, false);
      requestOtpBtn.disabled = true;
    } else if (result.error) {
      showGeneralError(result.error);
      setFormDisabled(form, false);
    } else if (result.message && result.code === 200) {
      hideFormDescription();
      hideRequestOtpForm();
      showVerifyOtpForm(formData.get('phone'));
      setFormDisabled(form, false);
    }
  } catch (error) {
    console.log({ error });
    showGeneralError('Something went wrong. Please try again.');
    setFormDisabled(form, false);
  }
}

async function handleVerifyOtp(e) {
  e.preventDefault();

  const form = document.querySelector('[data-verify-otp-form]');
  if (!form) return;

  const formData = new FormData(form);

  resetFormErrors(form);
  resetGeneralMessages();

  const otp = window.getOtpValue();
  const otpInputsLength = window.getOtpInputsLength();

  if (otp.length !== otpInputsLength) {
    showFieldErrors({
      otp: ['Code should be of 6 digits'],
    });
    return;
  }

  formData.append('otp', otp);

  try {
    setFormDisabled(form);

    const res = await fetch(`${ASTRID_PORTAL_APP_URL}/api/patient/verify-otp`, {
      method: 'POST',
      body: formData,
    });

    const result = await res.json();

    if (result.error?.fieldErrors) {
      showFieldErrors(result.error.fieldErrors);
      setFormDisabled(form, false);
    } else if (result.error) {
      showGeneralError(result.error);
      setFormDisabled(form, false);
    } else if (result.message && result.code === 200) {
      hideOtpTimer();
      submitCustomerLoginForm(result.data);
      clearCart();
      localStorage.setItem('profileSetupInitialized', 'false');
    }
  } catch (error) {
    console.log({ error });
    showGeneralError('Something went wrong. Please try again.');
  }
}

function resetFormErrors(form) {
  form.querySelectorAll('.error-message').forEach((el) => el.remove());
  form.querySelectorAll('.error').forEach((el) => el.classList.remove('error'));
  form.querySelectorAll('.error-icon').forEach((el) => el.classList.add('twcss:hidden'));
}

function resetGeneralMessages() {
  const generalError = document.getElementById('general-error');
  if (generalError) {
    generalError.textContent = '';
    generalError.classList.add('twcss:hidden');
  }

  const generalSuccess = document.getElementById('general-success');
  if (generalSuccess) {
    generalSuccess.textContent = '';
    generalSuccess.classList.add('twcss:hidden');
  }
}

function showFieldErrors(fieldErrors) {
  Object.entries(fieldErrors).forEach(([field, messages]) => {
    const errorMessage = messages.join(', ');
    const fieldElement = document.querySelector(`[name="${field}"]`);

    if (fieldElement) {
      fieldElement.classList.add('error');

      const inputWrapper = fieldElement.parentElement?.classList.contains('input-wrapper')
        ? fieldElement.parentElement
        : fieldElement.closest('.input-wrapper');

      if (inputWrapper) {
        const errorIcon = inputWrapper?.querySelector('.error-icon');
        if (errorIcon) {
          errorIcon.classList.remove('twcss:hidden');
        }

        const errorElement = document.createElement('div');
        errorElement.classList.add('error-message');
        errorElement.textContent = errorMessage;
        errorElement.classList.add('twcss:mb-[14px]', 'twcss:text-center', 'twcss:max-w-[449px]');

        inputWrapper.insertAdjacentElement('afterend', errorElement);
      }
    }
  });
}

function showGeneralError(message) {
  const generalError = document.getElementById('general-error');
  if (generalError) {
    generalError.textContent = message;
    generalError.classList.remove('twcss:hidden');
  }
}

function hideFormDescription() {
  const formDescription = document.getElementById('form-description');
  if (formDescription) {
    formDescription.classList.add('twcss:hidden');
  }
}

function hideRequestOtpForm() {
  const form = document.querySelector('[data-request-otp-form]');
  if (!form) return;

  form.classList.add('twcss:hidden');
}

function showVerifyOtpForm(phone) {
  const form = document.querySelector('[data-verify-otp-form]');
  if (!form) return;

  form.classList.remove('twcss:hidden');

  const hiddenPhoneInput = form.querySelector('input[type="hidden"]#otp-requested-phone');
  hiddenPhoneInput.setAttribute('value', phone);

  showOtpTimer();
}

function hideOtpTimer() {
  if (otpTimerIntervalId) {
    clearInterval(otpTimerIntervalId);
    otpTimerIntervalId = null;
  }
  const timerElement = document.querySelector('.otp-timer');
  if (timerElement) {
    timerElement.innerHTML = '';
    timerElement.style.display = 'none';
  }
}

function submitCustomerLoginForm(result) {
  const email = result.email;
  const password = result.password;

  const loginForm = document.querySelector('[data-customer-login-form]');

  if (loginForm) {
    const emailInput = loginForm.querySelector('input[name="customer[email]"]');
    const passwordInput = loginForm.querySelector('input[name="customer[password]"]');

    if (emailInput && passwordInput) {
      emailInput.value = email;
      passwordInput.value = password;

      loginForm.submit();
    }
  }
}

function setFormDisabled(form, disabled = true) {
  const elements = form.querySelectorAll('input, button, .resend-otp-link');
  elements.forEach((el) => {
    el.disabled = disabled;
  });
}

function showOtpTimer() {
  const form = document.querySelector('[data-verify-otp-form]');
  if (!form) return;

  let timerElement = form.querySelector('.otp-timer');
  if (!timerElement) {
    timerElement = document.createElement('div');
    timerElement.classList.add('otp-timer', 'twcss:text-sm', 'twcss:text-gray-600');
    form.appendChild(timerElement);
  }
  timerElement.style.display = '';

  let remaining = OTP_EXPIRATION_DURATION_IN_SECONDS;

  if (otpTimerIntervalId) {
    clearInterval(otpTimerIntervalId);
    otpTimerIntervalId = null;
  }

  function updateTimer() {
    if (remaining > 0) {
      const seconds = remaining % 60;
      timerElement.textContent = `Code expires in ${seconds.toString().padStart(2, '0')} seconds`;
      remaining--;
    } else {
      clearInterval(otpTimerIntervalId);
      otpTimerIntervalId = null;
      timerElement.innerHTML = 'Code expired.';

      const resendDiv = document.createElement('div');
      resendDiv.textContent = 'RESEND CODE';
      resendDiv.classList.add(
        'twcss:bg-transparent',
        'twcss:hover:bg-primary-500',
        'twcss:hover:text-accent-500',
        'twcss:border-1',
        'twcss:text-center',
        'twcss:border-primary-500',
        'twcss:cursor-pointer',
        'twcss:text-primary-500',
        'twcss:hover:bg-primary-500',
        'twcss:text-xs',
        'twcss:py-[14px]',
        'twcss:px-4',
        'twcss:rounded-[7px]',
        'twcss:w-full',
        'twcss:transition',
        'twcss:duration-200',
        'twcss:leading-[150%]',
        'twcss:max-w-[449px]',
        'twcss:mt-[9px]'
      );
      resendDiv.addEventListener('click', handleResendOtp);

      timerElement.appendChild(resendDiv);

      const verifyOtpBtn = document.querySelector('[data-verify-otp]');
      if (verifyOtpBtn) verifyOtpBtn.disabled = true;
    }
  }

  updateTimer();
  otpTimerIntervalId = setInterval(updateTimer, 1000);

  function handleResendOtp(e) {
    e.preventDefault();
    resendOtp();
  }

  async function resendOtp() {
    const form = document.querySelector('[data-verify-otp-form]');
    if (!form) return;

    const phone = form.querySelector('input[type="hidden"]#otp-requested-phone').value;

    const requestForm = document.createElement('form');
    const phoneInput = document.createElement('input');
    phoneInput.name = 'phone';
    phoneInput.value = phone;
    requestForm.appendChild(phoneInput);

    const formData = new FormData(requestForm);

    resetFormErrors(form);
    resetGeneralMessages();

    try {
      setFormDisabled(form);

      const res = await fetch(`${ASTRID_PORTAL_APP_URL}/api/patient/request-otp`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.error?.fieldErrors) {
        showFieldErrors(result.error.fieldErrors);
      } else if (result.error) {
        showGeneralError(result.error);
      } else if (result.message && result.code === 200) {
        timerElement.innerHTML = '';
        showOtpTimer();
        const verifyOtpBtn = document.querySelector('[data-verify-otp]');
        if (verifyOtpBtn) verifyOtpBtn.disabled = false;
      }
    } catch (error) {
      showGeneralError('Something went wrong. Please try again.');
    } finally {
      setFormDisabled(form, false);
    }

    window.clearOtpInputs && window.clearOtpInputs();

    const verifyOtpBtn = document.querySelector('[data-verify-otp]');
    if (verifyOtpBtn) verifyOtpBtn.disabled = true;
  }
}

function validateForm(e) {
  const form = e.currentTarget.closest('form');
  if (!form) return;

  const isRequestOtpForm = form.hasAttribute('data-request-otp-form');
  const isVerifyOtpForm = form.hasAttribute('data-verify-otp-form');
  const submitButton = isRequestOtpForm
    ? document.querySelector('[data-request-otp]')
    : document.querySelector('[data-verify-otp]');

  if (!submitButton) return;

  let isFormValid = true;

  if (isRequestOtpForm) {
    const phoneInput = form.querySelector('[name="phone"]');
    if (!phoneInput) return;

    if (!isValidPhone(phoneInput.value)) {
      isFormValid = false;
      //   showError(phoneInput, 'Please enter a valid Australian mobile number (04XX XXX XXX or 4XX XXX XXX)');
      showError(phoneInput, '');
    } else {
      clearError(phoneInput);
    }
  } else if (isVerifyOtpForm) {
    if (!otpTimerIntervalId) {
      isFormValid = false;
      return;
    }

    const otp = window.getOtpValue();
    const otpInputsLength = window.getOtpInputsLength();

    if (otp.length !== otpInputsLength) {
      isFormValid = false;
      const otpContainer = document.querySelector('.otp-inputs-container');
      if (otpContainer && !otpContainer.querySelector('.error-message')) {
        // showError(otpContainer, `OTP code should be ${otpInputsLength} digits`);
        showError(otpContainer, '');
      }
    } else {
      const otpContainer = document.querySelector('.otp-inputs-container');
      if (otpContainer) {
        clearError(otpContainer);
      }
    }
  }

  submitButton.disabled = !isFormValid;
}

function isValidPhone(phone) {
  try {
    const phoneNumber = libphonenumber.parsePhoneNumber(phone, 'AU');
    return phoneNumber && phoneNumber.isValid();
  } catch (e) {
    return false;
  }
}

function showError(inputEl, message) {
  inputEl.classList.add('error');
  const inputWrapper = inputEl.parentElement?.classList.contains('input-wrapper')
    ? inputEl.parentElement
    : inputEl.closest('.input-wrapper');
  if (!inputWrapper) return;
  const existingError = inputWrapper.nextElementSibling;
  if (existingError && existingError.classList.contains('error-message')) {
    existingError.textContent = message;
    return;
  }
  const errorElement = document.createElement('div');
  errorElement.classList.add('error-message', 'twcss:text-center', 'twcss:max-w-[449px]');
  errorElement.textContent = message;
  const errorIcon = inputWrapper?.querySelector('.error-icon');
  if (errorIcon) {
    errorIcon.classList.remove('twcss:hidden');
  }
  inputWrapper.insertAdjacentElement('afterend', errorElement);
}

function clearError(inputEl) {
  inputEl.classList.remove('error');
  const inputWrapper = inputEl.parentElement?.classList.contains('input-wrapper')
    ? inputEl.parentElement
    : inputEl.closest('.input-wrapper');
  if (!inputWrapper) return;
  const existingError = inputWrapper.nextElementSibling;
  if (existingError && existingError.classList.contains('error-message')) {
    existingError.remove();
  }
  const errorIcon = inputWrapper?.querySelector('.error-icon');
  if (errorIcon) {
    errorIcon.classList.add('twcss:hidden');
  }
}

function clearCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error clearing cart:', error);
    });
}
